import { render, staticRenderFns } from "./PreviewModelFullModal.vue?vue&type=template&id=24ae2f4e&scoped=true"
import script from "./PreviewModelFullModal.vue?vue&type=script&lang=js"
export * from "./PreviewModelFullModal.vue?vue&type=script&lang=js"
import style0 from "../styles/preview-model.scss?vue&type=style&index=0&id=24ae2f4e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ae2f4e",
  null
  
)

export default component.exports